import { action } from 'satcheljs';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';

/**
 * setCalendarItems action
 */
export default action('setCalendarItems', (events: CalendarItem[], replaceAll: boolean) => ({
    events,
    replaceAll,
}));
